import { Injectable } from '@angular/core';
import { BehaviorSubject, map, mergeMap, tap } from 'rxjs';
import { CoreItemType } from '../core-item/core-item';
import { CoreItemService } from '../core-item/core-item.service';
import { Interview } from '../interview/interview';
import { InterviewMessage, InterviewMessageSubData } from './interview-message';

@Injectable({
  providedIn: 'root',
})
export class InterviewMessageService {
  private _changeSubject = new BehaviorSubject<InterviewMessage | undefined>(undefined);

  constructor(private coreItemService: CoreItemService) {}

  getInterviewMessageListById$(interviewId: string) {
    return this._changeSubject.asObservable().pipe(
      mergeMap((_) => {
        return this.coreItemService
          .getCoreItemList$([CoreItemType.interviewMessage], interviewId)
          .pipe(
            map(
              (list) =>
                (list?.filter((item) => item.coreType === CoreItemType.interviewMessage) as InterviewMessage[]) ?? []
            )
          );
      })
    );
  }

  addInterviewMessage$(interview: Interview, subData: InterviewMessageSubData) {
    return this.coreItemService
      .batchWriteMetadataAndRelationList$({
        addMetadataList: [
          {
            coreType: CoreItemType.interviewMessage,
            subData,
            parentId: interview.id,
          },
        ],
        notChangeLoadingStatus: true,
      })
      .pipe(
        map((arr) => {
          this._changeSubject.next(arr[0] as InterviewMessage);
          return arr[0] as InterviewMessage;
        })
      );
  }

  deleteInterviewMessageList$(interviewMessageList: InterviewMessage[]) {
    const deleteMetadataList = interviewMessageList.map((c) => ({
      id: c.id,
      sk: c.sk,
    }));

    return this.coreItemService
      .batchWriteMetadataAndRelationList$({
        deleteMetadataList,
      })
      .pipe(
        tap((_) => {
          this._changeSubject.next(undefined);
        })
      );
  }
}
